import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Tabs, Tab, Form, Button } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import moment from "moment";
import { BettingProfitLossTabNew } from "./BettingProfitLossTabNew";
import { isEmpty } from "lodash";

const BettingProfitLossNew = () => {
  const params = useParams();
  const location = useLocation();
  let { user ,setAccountError} = useContext(AuthContext);
  const [key, setKey] = useState("Exchange");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [data2, setData2] = useState({});
  const [innertab, setInnertab] = useState("all");
  const [total2, setTotal2] = useState(0);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    toPeriod: currentDate,
    fromPeriod: previousDate,
    // userType: "user",
    // id: "67580dd63d2e7e8f4e070ba1",
    userName: "",
    page: 1,
    limit: 100,
    status: "completed",
  });
  const [data, setData] = useState([]);
  const getData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let path = apiPath.betProfitLoss;

    let obj = {
      ...filter,
      userType: isEmpty(filter?.userName) ? user?.userType : "",
      id: isEmpty(filter?.userName) ? user?._id : "",
      betType:
        key == "Exchange"
          ? "betfair"
          : key == "FancyBet"
          ? "fancy"
          : key == "Sportsbook"
          ? "sportBook"
          : key == "BookMaker"
          ? "bookmaker"
          : key == "Tie"
          ? "tie"
          : key == "Toss"
          ? "toss"
          : key == "parlay"
          ? "parlay"
          : "casino",
    };

    const { status, data: response_users } = await apiGet(path, obj);
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results.data?.length == 0) {
          setAccountError(true);
        } else {
          setAccountError(false);
        }
        setData(response_users.results);
        setData2(response_users?.results);
        setInnertab("all");
        if (response_users?.results?.data?.length > 0) {
          let result = handelChange(response_users?.results?.data, key);
          setTotal(result);
          setTotal2(result);
        }
        // if (response_users?.results?.data?.length == 0) {
        //   setAccountError(true);
        // } else {
        //   setAccountError(false);
        // }
      } else {
        setData("");
        // setAccountError(true);
      }
    }
  };

  const handelChange = (value, newTab) => {
    let temp = value
      ?.filter((res) => {
        return res?.bets_list?.length > 0;
      })
      ?.map((item) => {
        const backTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.betType === "back" && v?.teamSelectionWin === v?.selectionId) {
            a = parseFloat(a) + parseFloat(v.profitAmount);
          }

          return a;
        }, 0);
        const backTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.betType === "back" && v?.teamSelectionWin !== v?.selectionId) {
            a = parseFloat(a) + parseFloat(v.loseAmount);
          }
          return a;
        }, 0);

        let backSubTotalresult =
          backTotalProfitAmount > backTotalLoseAmount
            ? backTotalProfitAmount - backTotalLoseAmount
            : -(backTotalLoseAmount - backTotalProfitAmount);

        const layTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.betType === "lay" && v?.teamSelectionWin !== v?.selectionId) {
            a = parseFloat(a) + parseFloat(v.profitAmount);
          }
          return a;
        }, 0);

        const layTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.betType === "lay" && v?.teamSelectionWin === v?.selectionId) {
            a = parseFloat(a) + parseFloat(v.loseAmount);
          }
          return a;
        }, 0);

        let laySubTotalresult =
          layTotalProfitAmount > layTotalLoseAmount
            ? layTotalProfitAmount - layTotalLoseAmount
            : -(layTotalLoseAmount - layTotalProfitAmount);
        let marketSubTotal = backSubTotalresult + laySubTotalresult;
        const yesTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.type == "Yes" && v?.decisionRun >= v?.betRun) {
            a = parseFloat(a) + parseFloat(v.profitAmount);
          }
          return a;
        }, 0);

        const yesTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.type == "Yes" && v?.decisionRun < v?.betRun) {
            a = parseFloat(a) + parseFloat(v.loseAmount);
          }
          return a;
        }, 0);
        let yesSubTotalresult =
          yesTotalProfitAmount > yesTotalLoseAmount
            ? yesTotalProfitAmount - yesTotalLoseAmount
            : -(yesTotalLoseAmount - yesTotalProfitAmount);

        const noTotalProfitAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.type == "No" && v?.decisionRun < v?.betRun) {
            a = parseFloat(a) + parseFloat(v.profitAmount);
          }
          return a;
        }, 0);
        const noTotalLoseAmount = item?.bets_list?.reduce((a, v) => {
          if (v?.type == "No" && v?.decisionRun >= v?.betRun) {
            a = parseFloat(a) + parseFloat(v.loseAmount);
          }
          return a;
        }, 0);
        let noSubTotalresult =
          noTotalProfitAmount > noTotalLoseAmount
            ? noTotalProfitAmount - noTotalLoseAmount
            : -(noTotalLoseAmount - noTotalProfitAmount);

        let fancyMarketSubTotal = yesSubTotalresult + noSubTotalresult;
        let fancyNetAmount = fancyMarketSubTotal;
        let v = marketSubTotal > 0 ? marketSubTotal / 100 : "";
        let netAmount = 0;
        let betType =
          newTab == "Exchange"
            ? "betfair"
            : newTab == "sportsBook"
            ? "sportBook"
            : newTab;

        if (betType == "toss" || betType == "tie") {
          netAmount = marketSubTotal;
        } else if (betType == "FancyBet") {
          netAmount = fancyNetAmount;
        } else {
          netAmount = marketSubTotal - v;
        }

        return netAmount;
      });
    return temp.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
  };
  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };

  useEffect(() => {
    setFilter({
      toPeriod: currentDate,
      fromPeriod: previousDate,
      filterByDay: "",
      userType: params?.type,
      id: params?.id,
      page: 1,
      limit: 100,
    });
    setKey("Exchange");
  }, [location]);
  useEffect(() => {
    if (innertab == "all") {
      if (data?.data?.length > 0) {
        let result = handelChange(data?.data, key);
        setTotal2(result);
        setData2(data);
      }
    } else {
      let filtered =
        data?.data?.filter((res) => {
          return res?.eventType == innertab;
        }) || [];

      if (filtered?.length > 0) {
        let result = handelChange(filtered, key);
        setTotal2(result);
        setData2((prev) => {
          return {
            ...prev,
            data: filtered,
          };
        });
      } else {
        setData2([]);
        setTotal2(0);
      }
    }
  }, [innertab]);
  //   useEffect(() => {
  //     getData();
     
  //  }, [filter?.filterByDay]);
  return (
    <div className="top-header-inner">
      <section className="py-4 main-inner-outer">
        <Container fluid>
          <div className="accout_cols_outer">
            <div className="right_side">
              <div className="inner-wrapper">
                <h2 className="common-heading">Profit & Loss</h2>
                <Form.Control
                  placeholder="enter userId...."
                  style={{
                    height: "25px",
                    width: "170px",
                    marginBottom: "10px",
                    fontSize: "13px",
                  }}
                  onChange={(e) =>
                    setFilter((prev) => {
                      return { ...prev, userName: e.target.value };
                    })
                  }
                  value={filter?.userName}
                />
                <div className="common-tab">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => {
                      setKey(k);
                      setFilter({
                        ...filter,
                        betType: "",
                        status: "completed",
                        fromPeriod: previousDate,
                        toPeriod: currentDate,
                        filterByDay: "",
                        page: 1,
                        limit: 100,
                        // userType: params.type,
                        // id: params.id,
                      });
                      setData({});
                      setTotal(0);
                      setTotal2(0);
                      setInnertab("all");
                      setData2({});
                    }}
                  >
                    <Tab eventKey="Exchange" title="Exchange">
                      {key === "Exchange" && (
                        <BettingProfitLossTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"betfair"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          dataOld={data}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="FancyBet" title="FancyBet">
                      {key === "FancyBet" && (
                        <BettingProfitLossTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"fancy"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          dataOld={data}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="Sportsbook" title="Sportsbook">
                      {key === "Sportsbook" && (
                        <BettingProfitLossTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"sportBook"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data2}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          dataOld={data}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                    <Tab eventKey="BookMaker" title="BookMaker">
                      {key === "BookMaker" && (
                        <BettingProfitLossTabNew
                          url={location.pathname.split("/")[1]}
                          title={key}
                          betType={"bookmaker"}
                          setFilter={setFilter}
                          filter={filter}
                          data={data2}
                          dataOld={data}
                          getData={getData}
                          viewpage={viewpage}
                          handlePageClick={handlePageClick}
                          pageCount={pageCount}
                          total={total}
                          setInnertab={setInnertab}
                          innertab={innertab}
                          total2={total2}
                          handelChange={handelChange}
                        />
                      )}
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default BettingProfitLossNew;
